import {
    Paragraph, AlignmentType, TextRun
} from 'docx'

const emptyFieldText = 'No information provided.'

// Helper function to create paragraphs with line break support
export const createParagraphsWithLineBreaks = (text, style = 'MyNormalStyle', options = {}) => {
    const {
        alignment = AlignmentType.JUSTIFIED,
        spacing = { before: 100, after: 400 },
        bullet = null,
        italics = false
    } = options;

    if (!text || text.trim() === '') {
        return [
            new Paragraph({
                style,
                alignment,
                spacing,
                bullet,
                children: [
                    new TextRun({
                        text: emptyFieldText,
                        italics: true,
                    }),
                ],
            })
        ];
    }

    const lines = text.split(/\r?\n/);
    
    if (lines.length === 1) {
        // Single line
        return [
            new Paragraph({
                style,
                alignment,
                spacing,
                bullet,
                children: [
                    new TextRun({
                        text: text,
                        italics,
                    }),
                ],
            })
        ];
    }
    
    // Multiple lines - create separate paragraphs
    return lines.map((line, index) => 
        new Paragraph({
            style,
            alignment,
            spacing: {
                before: index === 0 ? spacing.before : 50,
                after: index === lines.length - 1 ? spacing.after : 50
            },
            bullet,
            children: [
                new TextRun({
                    text: line || ' ', // Use space for empty lines
                    italics,
                }),
            ],
        })
    );
}